export const LOADING_VEHICLE = "LOADING_VEHICLE";
export const GET_VEHICLE_LIST = "GET_VEHICLE_LIST";
export const GET_VEHICLEBYID = "GET_VEHICLEBYID";
export const REMOVE_VEHICLE = "REMOVE_VEHICLE";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";